import { render, staticRenderFns } from "./AddBookingCart.vue?vue&type=template&id=f2f83dd2&"
import script from "./AddBookingCart.vue?vue&type=script&lang=js&"
export * from "./AddBookingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports